import {analyticsApi, api} from "../AxiosInstance";


export function getDurationOfDeliveryApi(params) {
  return api().get("api/DashboardAnalytic/durationOfDelivery",{params});
}

export function getAnalyticsApi(params) {
  return api().get("/api/DashboardAnalytic/overall" ,{params})
}

export function getAccuracyOfDeliveryApi(params) {
  return api().get(`/api/DashboardAnalytic/accuracyOfDelivery`,{params});
}

export function getDistanceOfDeliveryApi(params) {
  return api().get(`/api/DashboardAnalytic/distanceOfDelivery` , {params});
}

export function getMissionStatusApi(params) {
  return api().get(`/api/DashboardAnalytic/missionStatus` , {params});
}
